import { CompanyContractConsumptionControlledBy } from "@/features/privateCompanies/types/companyContract.type";

export const consumptionControlledBy = {
  [CompanyContractConsumptionControlledBy.Currency]: 'Valor',
  [CompanyContractConsumptionControlledBy.Quantity]: 'Quantidade',
}
